module.exports = __webpack_public_path__ + "img/topBG.d293965c.png";